<template>
  <div class="index">
    <div class="index" v-if="showPage">
      <ranking-tab :period="current"></ranking-tab>
    </div>
  </div>
</template>

<script>
import APIRequest from '@/utils/APIRequest'
import RankingTab from '@/components/Games/RankingTab.vue'
import { getToken } from '@/utils/token'
import i18n from '@/i18n'
import { LanguageQueryMixin } from '@/mixins/LanguageQuery'

export default {
  components: {
    RankingTab,
  },
  mixins: [LanguageQueryMixin],
  title: i18n.t('gamesRankingTitle'),
  name: 'GamesRanking',
  data: function () {
    return {
      results: [],
      next: 1,
      periodId: this.$route.params.periodId,
      current: undefined,
      token: undefined,
    }
  },
  computed: {
    showPage: function () {
      return this.current !== undefined
    },
  },
  created() {
    this.token = this.getToken()
    this.fetchGamePeriod()
    this.allowScrolling(true)
  },
  methods: {
    handleTouchMove: function (e) {
      e.preventDefault()
    },
    getToken() {
      return getToken()
    },
    allowScrolling: function (val) {
      if (val) {
        document.body.className = 'body__scrolling'
        document.ontouchmove = () => true
      } else {
        document.body.className = 'body__nonscrolling'
        document.ontouchmove = (e) => e.preventDefault()
      }
    },
    fetchGamePeriod: async function () {
      const request = new APIRequest(
        this.$config.appGatewayServerUrl,
        '/game/period/get',
        {
          periodId: this.periodId,
        },
        {
          Authorization: `Bearer ${this.getToken()}`,
        }
      )
      const response = await fetch(request.url, {
        method: 'POST',
        headers: request.headers,
        body: JSON.stringify(request.data),
      })

      if (!response.ok) {
        //何もしない
        return
      }
      const payload = await response.json().then((json) => json.payload)
      this.current = payload.period
    },
  },
}
</script>

<style scoped>
.index {
  height: 100%;
  min-height: 850px;
  padding-bottom: var(--safe-area-inset-bottom, 0px);
}
</style>
